// mockData.js
export const MockData = {
  title: 'The Tortoise and the Hare Race',
  characters: [
    { name: 'Tortoise', description: 'A slow but determined character.' },
    { name: 'Hare', description: 'A fast but overconfident character.' },
    { name: 'Fox', description: 'A wise and fair referee.' },
  ],
  dialogue: [
    { character: 'Tortoise', text: 'I’m ready. Slow and steady is my motto.' },
    { character: 'Hare', text: 'Ready? Ha! This will be the easiest race of my life. I’ll be finished before the Tortoise even takes a few steps.' },
    { character: 'Fox', text: 'Very well. On your marks, get set... go!' },
    { character: 'Hare', text: 'See you at the finish line, Tortoise! Or maybe I’ll take a nap first. I’ll still win, no problem.' },
    { character: 'Tortoise', text: 'Keep going, Hare. I’ll get there in my own time.' },
    { character: 'Hare', text: 'Yawn... I’ve got plenty of time to rest. The Tortoise is so slow, I could even take two naps!' },
    { character: 'Tortoise', text: 'Step by step, I’m making progress. The finish line is closer than it seems.' },
    { character: 'Fox', text: 'Oh no! The Hare fell asleep halfway through the race! The Tortoise is still moving steadily.' },
    { character: 'Hare', text: 'What?! How did the Tortoise catch up? No matter, I’ll just sprint to the finish!' },
    { character: 'Tortoise', text: 'Just a little further... I can see the finish line!' },
    { character: 'Fox', text: 'And the Tortoise crosses the finish line! The Hare wakes up too late and loses the race!' },
    { character: 'Hare', text: 'How could this happen? I’m so much faster!' },
    { character: 'Tortoise', text: 'Speed isn’t everything, Hare. Consistency and determination can win the race.' },
    { character: 'Fox', text: 'A valuable lesson for us all. Congratulations, Tortoise! You’ve proven that slow and steady truly wins the race.' },
  ],
  assets: {
    characters: {
      Tortoise: '/assets/tortoise.jpeg', // Relative path to Tortoise image
      Hare: '/assets/hare.jpeg', // Relative path to Hare image
      Fox: '/assets/fox.jpeg', // Relative path to Fox image
    },
    backgroundImage: '/assets/backgroundImage.jpg', // Relative path to background image
    backgroundMusic: '/assets/backgroundMusic.mp3', // Relative path to background music
  },
};